let route = {
    path: '/modules/commodity/sys',
    name: 'commodity-sys',
    component: () => import('@/modules/commodity-sys/index.vue'),
    children: [
        {
            path: 'goods-manage',
            name: 'Commodity-Sys-GoodsManage',
            component: () => import('@/modules/commodity-sys/goods-manage/index.vue'),
            meta: {
                pageTitle: '商品管理',
            }
        },
        {  
            path: 'goods-manage/edit',
            name: 'Commodity-Sys-GoodsManage-Edit',
            component: () => import('@/modules/commodity-sys/goods-manage/edit.vue'),
            meta: {
                parent: '/modules/commodity/sys/goods-manage',
            }
        },
        {  
            path: 'spec-manage/edit',
            name: 'Commodity-Sys-SpecManage-Edit',
            component: () => import('@/modules/commodity-sys/spec-manage/edit.vue'),
            meta: {
                parent: '/modules/commodity/sys/goods-manage',
            }  
        },
        {
            path: 'category-manage',
            name: 'Commodity-Sys-CategoryManage',
            component: () => import('@/modules/commodity-sys/category-manage/index.vue'),
            meta: {
                pageTitle: '分类管理',
            }
        },
        {  
            path: 'category-manage/edit',
            name: 'Commodity-Sys-CategoryManage-Edit',
            component: () => import('@/modules/commodity-sys/category-manage/edit.vue'),
            meta: {
                parent: '/modules/commodity/sys/category-manage',
            }   
        },
        {
            path: 'query/sn',
            name: 'Commodity-Sys-Query-Sn',
            component: () => import('@/modules/commodity-sys/query/sn.vue'),
            meta: {
                pageTitle: 'SN码查询',
            }
        },
        {
            path: 'price-manage/index',
            name: 'Commodity-Sys-Price-Manage',
            component: () => import('@/modules/commodity-sys/price-manage/index.vue'),
            meta: {
                pageTitle: '价格管理',
            }
        },
        {
            path: 'on-shelves/index',
            name: 'Commodity-Sys-On-Shelves',
            component: () => import('@/modules/commodity-sys/on-shelves/index.vue'),
            meta: {
                pageTitle: '商品上架',
            }
        },
        {  
            path: 'on-shelves/edit',
            name: 'Commodity-Sys-On-Shelves-Edit',
            component: () => import('@/modules/commodity-sys/on-shelves/edit.vue'),
            meta: {
                parent: '/modules/commodity/sys/on-shelves/index',
            }
        },
        {
            path: 'main-manage/index',
            name: 'Commodity-Sys-Main-Manage',
            component: () => import('@/modules/commodity-sys/main-manage/index.vue'),
            meta: {
                pageTitle: '主体管理',
            }
        }
    ],
    
};
export const CommoditySysRuter = route;
